exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".show-member .panel {\n  padding: 2rem 1rem; }\n\n.show-member .title {\n  color: #7091c5; }\n\n.show-member .name {\n  font-size: 150%;\n  font-weight: bold; }\n\n.show-member .location {\n  color: #2455a5;\n  padding-bottom: 1rem; }\n  .show-member .location .fa {\n    padding-right: 0.25rem;\n    color: #7091c5; }\n\n.show-member .email .fa, .show-member .phone .fa {\n  color: #898a8e;\n  padding-right: 0.25rem; }\n\n.show-member .data {\n  font-size: 120%;\n  margin-top: 0.125rem;\n  margin-bottom: 2rem; }\n  .show-member .data.company-name {\n    font-weight: bold; }\n  .show-member .data.about {\n    color: #898a8e; }\n\n.show-member .file-input {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/members/show-member/show-member.component.scss
// module id = 403
// module chunks = 0